import { useMemo } from "react";
import {
  TableData,
  FilterSearchOption,
  isSupportedSearchableValue,
} from "./tableUtils";

export default function useFilteredData<T extends TableData>(
  dataSource: T[],
  filterSearchOption?: FilterSearchOption,
): T[] {
  return useMemo(() => {
    if (!filterSearchOption?.enabled || !filterSearchOption.searchValue) {
      return dataSource;
    }

    const searchValue = filterSearchOption.searchValue.toLowerCase();

    const searchKeys =
      filterSearchOption.searchKeys ||
      (dataSource.length > 0 ? Object.keys(dataSource[0]) : []);

    const filtered = dataSource.filter((item) =>
      searchKeys.some((key) => {
        const value = item[key];
        return (
          isSupportedSearchableValue(value) &&
          value.toString().toLowerCase().includes(searchValue)
        );
      }),
    );

    return filtered;
  }, [dataSource, filterSearchOption]);
}
